import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import Tasks from 'APP/Tasks';
import { CompactViewCalendar } from 'APP/main/RightSidebarManager/components/CompactView/CompactViewCalendar';
import { RouterLink } from 'APP/router/constants';
import Entities from 'STORE';

interface ICompactViewCalendarPresenter {
  isCompactViewEnabled: boolean;
  isActiveAccount: boolean;
  isCalendarEnabled: boolean;
}

export function useCompactViewCalendarPresenter(): void {
  const location = useLocation();

  const presenter = useLocalObservable<ICompactViewCalendarPresenter>(() => ({
    get isCalendarEnabled(): boolean {
      return Entities.featuresStore.isCalendarIntegrationEnabled;
    },

    get isCompactViewEnabled(): boolean {
      return Entities.calendar.isCompactViewEnabled;
    },

    get isActiveAccount(): boolean {
      return Entities.calendar.isActiveAccount;
    },
  }));

  useEffect(() => {
    Tasks.calendar.checkAuthorizationAccounts();
  }, []);

  useEffect(() => {
    if (!presenter.isCalendarEnabled) {
      return;
    }

    if (
      !presenter.isCompactViewEnabled ||
      RouterLink.Calendar === location.pathname ||
      !presenter.isActiveAccount
    ) {
      Tasks.app.closeRightSidebarItem('compactCalendar');
      return;
    }

    Tasks.app.openRightSidebarItem('compactCalendar', CompactViewCalendar);
  }, [
    presenter.isCompactViewEnabled,
    location.pathname,
    presenter.isActiveAccount,
    presenter.isCalendarEnabled,
  ]);
}
